import session from '@/common/utils/session'

export function preTool (config) {
  let { inPre, switchIsProd } = config
  if (inPre) {
    let el = document.createElement('div')
    el.innerText = switchIsProd ? 'On-line' : 'Pre'
    Object.assign(el.style, {
      'position': 'fixed',
      'top': '10px',
      'left': '80%',
      'z-index': '9999',
      'padding': '6px',
      'background-color': '#ff6325',
      'font-size': '18px',
      'color': '#FFF',
      'border-radius': '4px',
      'box-shadow': '#CCC 0 0 6px 2px'
    })
    el.addEventListener('click', function () {
      if (switchIsProd) {
        session.removeItem('isProd')
      } else {
        session.setItem('isProd', true)
      }
      window.location.reload()
    }, false)

    // 添加拖拽事件
    el.addEventListener('touchmove', function (event) {
      let touch = event.targetTouches[0]
      let width = el.offsetWidth
      let height = el.offsetHeight
      el.style.left = touch.pageX - parseInt(width / 2) + 'px'
      el.style.top = touch.pageY - parseInt(height / 2) + 'px'
    }, false)
    document.body.appendChild(el)
  }
}
